<template>
  <ml-input v-if="readonly" :value="selectValue" readonly class="w-full flex-1" />
  <vs-select v-else v-model="selectIndex" autocomplete :disabled="disabled" :placeholder="placeholder" @input="onChange">
    <vs-select-item v-for="(option, option_i) in options" :value="option_i" :text="option.text || option.value" :key="`select-item-${option_i}-${option.value}`"/>
  </vs-select>
</template>

<script>
export default {
  name: "CustomOptionSelectorObject",
  props: {
    value: Object || null,
    options: Array,
    disabled: Boolean,
    readonly: Boolean,
    placeholder: {
      type: String,
      default: "선택",
    },
  },
  data() {
    return {
      selectIndex: this.value && this.value.index,
    };
  },
  watch: {
    value: {
      handler(value) {
        this.selectIndex = value && value.index;
      },
    },
    selectIndex: {
      immediate: true,
      deep: true,
      handler(value) {
        const find = this.options.find((_op, _op_i) => value === _op_i);
        this.$emit("input", !!find ? { ...find, index: value } : null);
      },
    },
  },
  methods: {
    onChange () {
      const find = this.options.find((_op, _op_i) => this.selectIndex === _op_i);
      this.$emit("change", !!find ? { ...find, index: this.selectIndex } : null);
    },
  },
  computed: {
    selectValue() {
      if (this.selectIndex === null) return "";
      if (this.options[this.selectIndex] === undefined) return "";
      return this.options[this.selectIndex].value;
    },
  },
};
</script>

<style scoped></style>
